<template>
  <div class="template-item-wrapper" @click.stop="toTemplateDetailFunc()">
    <img class="template-item-img" :src="data.img" alt="">

    <div class="template-item-info">
      <h6>
        <img v-show="data.price > 0" src="https://files.wondercv.com/pc/nuxt/member.png" alt="member">
        <span>{{ data.name }}</span>
      </h6>
      <p>{{ data.desc }}</p>
      <div class="template-item-bottom">
        <span>{{ data.people_count || 0 }}人使用</span>
        <button @click.stop="debounce(() => { useTemplateFunc() }, 300)">使用模板</button>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api'
import moment from 'moment'
import { mapState } from 'vuex'
import { routerTo, get_tUser } from '@/assets/js/util'
import { componentsMixin } from '@/assets/js/mixins/components'

export default {
  props: {
    // 单个模板数据
    data: {
      type: Object,
      default: {}
    }
  },
  mixins: [ componentsMixin ],
  data () {
    return {
      moment,
      useStateShow: false
    }
  },
  components: {
  },
  computed: {
  ...mapState('me', [ 'isMembership', 'personInfo' ])
  },
  created(){
  },
  methods: {
    // 跳转到 简历模板详情页
    toTemplateDetailFunc () {
      routerTo(`/muban/${this.data.token}`)
    },
    // 使用 当前简历模板
    async useTemplateFunc () {
      if(!this.isMembership && (this.data.price > 0)){
        routerTo(`/account/users/buy_member`,'_blank')
        return
      } else if (!this.useStateShow) {

        try {
          let { c_t } = get_tUser()
          this.useStateShow = true
          let res = await api.cvsEditor.canCreateCv(c_t)
          if (res.code === 1000) {
              this.useStateShow = false
              if (res.data[`can_create_cn_cv`]) {
                  window.location.href = `${ window.location.origin }/cvs/${ this.data.cv_token }/editor`
              } else {
                  if (this.personInfo.is_membership) {
                      this.$message.error('已达简历数量上限')
                  } else {
                      this.$message.error('已达简历上限，升级会员可创建多份简历')
                      setTimeout(() => {
                          this.$store.dispatch('app/setAlertData', {show: true, type: 'upVip', browseType: 'useTemplate'})
                      }, 300)
                  }
              }
          } else {
              this.useStateShow = false
              console.log('接口报错')
          }
        } catch (error) {
          console.log(error)
        }

      }

    }
  }
}
</script>

<style lang="sass" scoped>
  @import "./index.scss";
</style>
